const AUTH_TOKEN_KEY = 'appToken';
const HAIAH_PREFIX = 'haiah_app';
const EMAIL_PASSWORD = 'passMail';
const PATIENT_INFO = 'infoPatient';

export { AUTH_TOKEN_KEY, HAIAH_PREFIX, EMAIL_PASSWORD, PATIENT_INFO };
